import { Component } from '@angular/core';
import { ListComponent } from '../../common/component/list.component';

@Component({
	selector: 'app-season-list',
	templateUrl: './season-list.component.html',
	styleUrls: ['./season-list.component.scss'],
})
export class SeasonListComponent extends ListComponent {
	protected apiUrl = 'reservation/season';
	protected apiType = 'bag';
	codebook = null;
	title: string;
	tableRows = [
		{ id: 'name', name: 'Nazwa' },
		{ id: 'lower', name: 'Od' },
		{ id: 'upper', name: 'Do' },
	];

	protected convertData(data) {
		return data.results.map((item) => {
			const { lower, upper } = item.dateRange;
			return {
				...item,
				lower: this.date.formatDateToGivenLocale(lower, 'pl-PL'),
				upper: this.date.formatDateToGivenLocale(upper, 'pl-PL'),
			};
		});
	}

	filters = {
		limit: 9999,
	};

	protected loadBefore(): void {
		this.bag.get('/codebook/16/', (result, error) => {
			this.codebook = result;

			this.title = `Słowniki -> ${this.codebook.name}`;
			this.loadData();
		});
	}
}
